<template align="center">
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        전체 탐지 중 {{so.perPage}} 개
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WSFinder</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">상황판</a>
        </li>
      </ul>
    </div>
    <div class="alert">
      <div class="row mb-2">
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <strong>마지막 시스템 패턴</strong>
        </div>
        <div class="col-xl-4 col-md-12 d-flex align-self-center">
          <span v-if="pattern" >{{ pattern.created_at | datetime}}</span>
          <span v-else >-</span>
        </div>
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <span v-if="pattern" >{{ codes.code_type[pattern.type || ''] }}</span>
        </div>
        <div class="col-xl-4 col-md-12 d-flex align-self-center">
          <span v-if="pattern" >{{ pattern.code | truncate(50) }}</span>
          <span v-else >-</span>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <div class="d-flex flex-wrap align-items-center mb10 mt-5">
      <b-col class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto"></div>
          <div class="mb7 form-inline">
            <label class="col-form-label mr-2" for="sel3">새로고침 간격</label>
            <select class="form-control mr-2" name="sel3" id="sel3" v-model="sync.interval" @change="refresh">
              <option disabled value="15"> 기본 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 분)</option>
            </select>
            <label class="col-form-label mr-2" for="sel3">초</label>
          </div>
          <div class="mr-2 mb7"></div>
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="15">표시되는 개수 : 기본 15개</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </b-input-group>
        <br>
        <b-input-group>
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || '찾기'" v-model="so.sk">
              <option disabled value="">검색</option>
              <option value="group.groupname">회사명</option>
              <option value="category">룰</option>
              <option value="path">경로</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <b-form-input v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1" @click="refresh()">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="so.adv = true; set()">
              <i class="fas fa-search-plus"></i>
            </button> -->
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list"
            show-empty empty-text="관련된 정보가 없어요."
            :items="load" :fields="f_detect" :current-page="so.currentPage" :per-page="so.perPage">
            <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
            <template slot="group" slot-scope="row">{{row.item.group.groupname}}</template>
            <template slot="agent" slot-scope="row">{{`${row.item.agent.name}@${row.item.agent.ip_addr}`}}</template>
            <template slot="category" slot-scope="row">{{row.item.category}}</template>
            <template slot="path" slot-scope="row">{{row.item.path | truncate(100) }}</template>

            <template slot="func" slot-scope="row">
              <b-btn class="btn btn-sm btn-insert" @click="detail(row.item)" size="sm">더보기</b-btn>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>